
$(function () {
  
  // fade-in
  var fadeIn = $('.fade-in');
  $(window).scroll(function () {
    $(fadeIn).each(function () {
      var offset = $(this).offset().top;
      var scroll = $(window).scrollTop(); 
      var windowHeight = $(window).height();
      if (scroll > offset - windowHeight + 200) {
        $(this).addClass("scroll-in");
      }
    });
  });
  var fadeInSlow = $('.fade-in-slow');
  $(window).scroll(function () {
    $(fadeInSlow).each(function () {
      var offset = $(this).offset().top;
      var scroll = $(window).scrollTop(); 
      var windowHeight = $(window).height();
      if (scroll > offset - windowHeight + 400) {
        $(this).addClass("scroll-in");
      }
    });
  });


  //img-wrap
  $(window).scroll(function () {
    $(".img-wrap").each(function () {
      var offset = $(this).offset().top;
      var scroll = $(window).scrollTop(); 
      var windowHeight = $(window).height();
      if (scroll > offset - windowHeight + 200) {
        $(this).addClass("img-wrap--left");
      }
    });
  });
  

  //slideshow
  const pics_src = ["","",""];
  let num = -1;
  function slideshow_timer(){
     if (num === 2){
       num = 0;
     } 
     else {
       num ++;
     }
  }
  setInterval(slideshow_timer, 1000);

  
$(window).load(function () { //全ての読み込みが完了したら実行
  $('.loader').delay(900).fadeOut(800);
});



});